import React, { Dispatch, SetStateAction } from 'react'
import './styles.scss'
import { Candle } from 'components/Candle'

interface Props {
  content: MarkedInterface
  openmodal: Dispatch<SetStateAction<MarkedInterface | undefined>>
  locales: { lang: 'de' | 'fr'; years: string; readmore: string }
  pos:number
}

export const MarkedDeath = ({ content, openmodal, locales,pos }: Props) => {
  const { type, name, age, textde, textfr, sex, textid } = content
  return (
    <div className={`MarkedDeath ${type} ${sex} `}>
      <div className='candlewrapper'>
        {' '}
        <Candle sex={sex} className=' marked' pos={pos} />
      </div>
      <div className='textwrapper'>
        <div className='name'>{name}</div>
        {(type === 'short' || type === 'shortlong') && (
          <div className='text'>
            {age} {locales.years}{' '}
            {type === 'shortlong' && textid && (
              <span className='more' onClick={() => openmodal(content)}>
                {locales.readmore}...
              </span>
            )}
          </div>
        )}
        {(type === 'long' || type === 'middle') && (
          <div className='text'>
            {age} {locales.years} –{' '}
            {locales.lang === 'de' ? textde || '' : textfr || ''}{' '}
            {type === 'long' && textid && (
              <span className='more' onClick={() => openmodal(content)}>
                {locales.readmore}...
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
